import request from '../request';

export function index(params) {
  return request({
    url: "/manager/manage-income-deliveries",
    method: "get",
    params
  })
}

export function update(data) {
  return request({
    url: `/manager/manage-income-deliveries/${data.id}`,
    method: "put",
    data
  })
}